/* Created by Jessica Sheu
   Pauses and resumes videos based on viewport visibility.
   Updated to support multiple videos on the same page.
*/

document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll(
    ".autoplay-video, video-component#custom-video video"
  );

  if (!videos.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          video.muted = true;
          video.playsInline = true;

          video.play().catch((err) => {
            console.log("Video autoplay prevented:", err);
          });
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: 0.05
    }
  );

  videos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;

    observer.observe(video);
  });

});